<script>
  import { createEventDispatcher } from 'svelte';

  import Textarea from '@components/Textarea.svelte';
  import Button from '@components/Button.svelte';
  import ListAuthors from '@app-components/ListAuthors.svelte';
  import { getCurrentUserStore } from '@stores/current_user';

  const dispatch = createEventDispatcher();

  export let group;
  export let recRequest = {};
  export let close;
  export let apiRequest;

  let saving = false;
  let currentUser = getCurrentUserStore('default');
  currentUser.role = 'admin';

  if (!recRequest.title) {
    recRequest.title = `${group.name}`;
  }

  if (!recRequest.description) {
    recRequest.description = `Looking for recommendations. Really appreciate any suggestions, thank you!`;
  }

  let save = function () {
    saving = true;

    apiRequest(
      {
        rec_request: {
          title: recRequest.title,
          description: recRequest.description,
        },
      },
      async (_resp) => {
        saving = false;
        dispatch('saved');
      }
    );
  };
</script>

<style style="text/scss" lang="scss">
  .share-label {
    font-size: 14px;
    opacity: 0.5;
    padding-left: 21px;
    font-weight: normal;
  }

  .step-title {
    text-align: center;
    font-size: 14px;
    line-height: 26px;
    font-weight: 500;
  }

  .ui-cancel {
    font-weight: 500;
    color: black;

    &:hover {
      opacity: 0.75;
    }
  }
</style>

<div class="step-title">Set Title & Description</div>
<div
  style="margin-top: 60px; margin-bottom: -10px; margin-left: -20px;
  margin-right: -20px;">
  <label
    style="font-size: 15px; display: block; font-weight: normal; opacity: 0.5;
    padding-left: 20px; margin-bottom: 10px;">
    Title
  </label>
  <Textarea
    textareaStyle="font-weight: 500; font-size: 25px; line-height: 42px;
    border-radius: 15px;"
    bind:value={recRequest.title}
    rows={2}
    name="rec_request[title]"
    errorStyle="margin-top: -15px; margin-bottom: 25px; padding-left: 20px;" />
</div>
<div style="margin-left: -20px; margin-right: -20px;">
  <label
    style="font-size: 15px; display: block; font-weight: normal; opacity: 0.5;
    padding-left: 20px; margin-bottom: 10px;">
    Description
  </label>
  <Textarea
    textareaStyle="font-weight: normal; font-size: 14px; line-height: 24px;
    border-radius: 15px;"
    bind:value={recRequest.description}
    rows={3}
    name="rec_request[description]" />
</div>
{#if currentUser.id}
  <div style="margin-bottom: 25px;">
    <ListAuthors group={group} authors={[currentUser]} />
  </div>
{/if}

<div style="margin-top: 60px; margin-left: auto; margin-right: auto; width: 275px">
  {#if saving}
    <Button text="<i class='fa fa-spin fa-spinner'></i>&nbsp;&nbsp;Saving" />
  {:else}
    <Button text="Next" on:click={save} />
  {/if}
  <div style="margin-top: 15px; display: block; text-align: center">
    <a href="#" class="ui-cancel" on:click={close}>Cancel</a>
  </div>
</div>
